import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 1rem 0;

  gap: ${props => props.gap || "1rem"};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  >img{
    width: 100%;
    height: auto;
    max-width: 80px;
  }

  >span{
    text-align: center;
  }
`;
